import { Controller } from 'stimulus'
import { buildDeliveryUI } from '../tiptap/document_delivery_ui'
import { buildDocumentExport } from '../tiptap/document_export'

// Saved documents use the same format chooser and preparation flow as the editor.
export default class extends Controller {
  static values = { wordUrl: String, pdfUrl: String, markdownUrl: String, title: String }

  open(event) {
    event.preventDefault()
    if (!this.ui) {
      this.ui = buildDeliveryUI()
      this.ui.dialog.addEventListener('close', () => this.release(), { once: true })
      this.exporter = buildDocumentExport(this.ui, {
        wordUrl: this.wordUrlValue, pdfUrl: this.pdfUrlValue,
        markdownUrl: this.markdownUrlValue, title: () => this.titleValue,
      })
    }
    this.ui.dialog.classList.toggle('chat-theme-dark', !!document.querySelector('body.chat-theme-dark, #currentTheme.chat-theme-dark'))
    const opener = this.element.closest('.dropdown, .dropup')?.querySelector('[data-toggle="dropdown"]') || this.element
    this.exporter.open('word', opener)
  }

  disconnect() { this.release() }

  release() {
    this.exporter?.destroy()
    this.ui?.destroy()
    this.exporter = null
    this.ui = null
  }
}
